var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.52,
    height: 55.52,
    viewBox: "0 0 55.52 55.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_element-4",
    "data-name": "vuesax/linear/element-4",
    transform: "translate(-684 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "element-4",
    transform: "translate(684 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.663,20.589V4.858C19.663,1.388,18.183,0,14.5,0H5.159C1.481,0,0,1.388,0,4.858V20.589c0,3.47,1.481,4.858,5.159,4.858H14.5C18.183,25.447,19.663,24.059,19.663,20.589Z",
    transform: "translate(31.23 4.627)",
    fill: "none",
    stroke: "#0098da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M19.663,9.022V4.858C19.663,1.388,18.183,0,14.5,0H5.159C1.481,0,0,1.388,0,4.858V9.022c0,3.47,1.481,4.858,5.159,4.858H14.5C18.183,13.88,19.663,12.492,19.663,9.022Z",
    transform: "translate(31.23 37.013)",
    fill: "none",
    stroke: "#0098da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M19.663,4.858V20.589c0,3.47-1.481,4.858-5.159,4.858H5.159C1.481,25.447,0,24.059,0,20.589V4.858C0,1.388,1.481,0,5.159,0H14.5C18.183,0,19.663,1.388,19.663,4.858Z",
    transform: "translate(4.627 25.447)",
    fill: "none",
    stroke: "#0098da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M19.663,4.858V9.022c0,3.47-1.481,4.858-5.159,4.858H5.159C1.481,13.88,0,12.492,0,9.022V4.858C0,1.388,1.481,0,5.159,0H14.5C18.183,0,19.663,1.388,19.663,4.858Z",
    transform: "translate(4.627 4.627)",
    fill: "none",
    stroke: "#0098da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H55.52V55.52H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashicon);
export default __webpack_public_path__ + "static/media/dashicon.07cb3d974336999ea8fd1183d60f6bae.svg";
export { ForwardRef as ReactComponent };